/*
  Dasom Essence - dual-currency display: every price shows BOTH currencies inline,
  "CA$189 / US$138" (USD muted), replacing the old bottom-left CA/US toggle widget
  (Kelvin 2026-07-09: two fixed prices don't need a switch; the toggle also overlapped
  the Skin Scan launcher). Display-only: checkout stays CAD. US prices are FIXED
  (configurable CAD->USD rate, rounded to whole dollars) so they do not float with FX.

  Config (set in the snippet before this script):
    window.DASOM_USD_RATE          e.g. 0.73  (CAD -> USD)
    window.DASOM_PRICE_SELECTORS   array of CSS selectors for price elements
*/
(function () {
  'use strict';
  var RATE = window.DASOM_USD_RATE || 0.73;
  var SELECTORS = window.DASOM_PRICE_SELECTORS || [
    '.price-item--regular', '.price-item--sale', '.price__regular .price-item',
    '[data-product-price]', '.product__price', '.price .money'
  ];

  function usdFor(cad) { return Math.round(cad * RATE).toLocaleString('en-US'); }
  function parseAmount(t) { var m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function priceEls() {
    var set = [];
    SELECTORS.forEach(function (s) { try { document.querySelectorAll(s).forEach(function (e) { set.push(e); }); } catch (x) {} });
    return set;
  }

  var mo = null;
  function apply() {
    // Disconnect the observer for the duration of our own DOM writes so they can
    // never retrigger us (innerHTML writes are childList mutations).
    if (mo) mo.disconnect();
    priceEls().forEach(function (el) {
      // Cache the original CAD text once; theme re-renders (variant change, cart
      // updates) replace nodes, so fresh nodes simply get cached + rewritten again.
      if (el.getAttribute('data-cad') === null) {
        var a0 = parseAmount(el.textContent);
        if (a0 === null) return;
        el.setAttribute('data-cad', el.textContent.trim());
        el.setAttribute('data-cad-amt', String(a0));
      }
      var r = region();
      if (el.getAttribute('data-dz-r') === r && el.querySelector('.dz-usd')) return; // rendered for this region
      var cad = el.getAttribute('data-cad');
      var amt = parseFloat(el.getAttribute('data-cad-amt'));
      if (isNaN(amt)) return;
      el.setAttribute('data-dz-r', r);
      // US shoppers see the US$ figure first (the number they think in); the CAD charge
      // currency stays visible beside it. Canadians keep CA$ first.
      if (r === 'US') el.innerHTML = 'US$' + usdFor(amt) +
        ' <span class="dz-usd" title="Checkout is in Canadian dollars">/ ' + esc(cad) + '</span>';
      else el.innerHTML = esc(cad) +
        ' <span class="dz-usd" title="Checkout is in Canadian dollars">/ US$' + usdFor(amt) + '</span>';
    });
    regionBlocks(); // still inside the observer-disconnected window
    if (mo) mo.observe(document.body, { childList: true, subtree: true });
  }
  // coalesce bursts of DOM activity into at most one apply per window
  var t_deb = null;
  function scheduleApply() { if (t_deb) return; t_deb = setTimeout(function () { t_deb = null; apply(); }, 300); }

  // ---- US-visitor launch-scarcity strip ----
  // Shown only to visitors in a US timezone (Canadian zones never match), only while
  // window.DASOM_US_SETS_LEFT > 0. The count is a real inventory number Kelvin/Nancy
  // maintain in the snippet config; set 0 (or remove) to retire the strip.
  var US_TZ = {
    'America/New_York': 1, 'America/Chicago': 1, 'America/Denver': 1, 'America/Phoenix': 1,
    'America/Los_Angeles': 1, 'America/Anchorage': 1, 'Pacific/Honolulu': 1, 'America/Detroit': 1,
    'America/Boise': 1, 'America/Juneau': 1, 'America/Sitka': 1, 'America/Nome': 1,
    'America/Menominee': 1, 'America/Metlakatla': 1, 'America/Yakutat': 1, 'America/Adak': 1
  };
  function isUsVisitor() {
    try {
      var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '');
      return !!US_TZ[tz] || /^America\/(Indiana|Kentucky|North_Dakota)\//.test(tz);
    } catch (e) { return false; }
  }

  // Region = where the customer says they're shipping to. A stated choice (the
  // "Shipping to" switcher near checkout) always beats the timezone auto-detect.
  function region() {
    try {
      var r = localStorage.getItem('dz_region');
      if (r === 'US' || r === 'CA') return r;
    } catch (e) {}
    return isUsVisitor() ? 'US' : 'CA';
  }
  function setRegion(r) {
    try { localStorage.setItem('dz_region', r); } catch (e) {}
    var strip = document.getElementById('dz-us-strip');
    if (strip) strip.remove();
    usStrip();
    apply(); // re-renders the region blocks too
  }

  function usStrip() {
    var left = parseInt(window.DASOM_US_SETS_LEFT, 10);
    if (!left || left < 1 || region() !== 'US') return;
    if (document.getElementById('dz-us-strip')) return;
    try { if (sessionStorage.getItem('dz_us_strip') === 'off') return; } catch (e) {}
    var el = document.createElement('div');
    el.id = 'dz-us-strip';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'US launch pricing');
    el.innerHTML =
      '<span class="dz-uss-txt"><b>US orders:</b> only <b>' + left + ' Transformation Sets</b> left at launch pricing with free shipping to the US. After that, full price and standard shipping.</span>' +
      '<a class="dz-uss-cta" href="/products/the-dasom-essence-transformation-set">Claim yours</a>' +
      '<button class="dz-uss-x" aria-label="Dismiss">&times;</button>';
    el.querySelector('.dz-uss-x').addEventListener('click', function () {
      el.remove();
      try { sessionStorage.setItem('dz_us_strip', 'off'); } catch (e) {}
    });
    document.body.insertBefore(el, document.body.firstChild);
  }

  // ---- Transformation Set sale strip with countdown (2026-08-26) ----
  // window.DASOM_SET_SALE is only defined by the Liquid snippet while the product has
  // a compare-at price above its price, so this cannot announce a sale that is not on.
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function countdownText(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d ? d + 'd ' : '') + pad2(h) + 'h ' + pad2(m) + 'm ' + pad2(s) + 's';
  }
  function cad(n) { return 'CA$' + Math.round(n).toLocaleString('en-CA'); }
  function saleStrip() {
    var sale = window.DASOM_SET_SALE;
    if (!sale || !sale.ends || !(sale.was > sale.price)) return;
    var ends = Date.parse(sale.ends);
    if (isNaN(ends) || ends <= Date.now()) return;
    if (document.getElementById('dz-sale-strip')) return;
    try { if (sessionStorage.getItem('dz_sale_strip') === 'off') return; } catch (e) {}
    var el = document.createElement('div');
    el.id = 'dz-sale-strip';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Limited-time sale');
    el.innerHTML =
      '<span class="dz-uss-txt"><b>' + (sale.title || 'The Transformation Set') + '</b>: save ' +
      '<b>' + cad(sale.was - sale.price) + '</b> for 7 days. <span class="dz-price">' + cad(sale.price) + '</span>, ' +
      '<span class="dz-price">' + cad(sale.was) + '</span> bought separately. ' +
      'Ends in <b class="dz-uss-timer" aria-live="off">' + countdownText(ends - Date.now()) + '</b></span>' +
      '<a class="dz-uss-cta" href="' + sale.url + '">Shop the set</a>' +
      '<button class="dz-uss-x" aria-label="Dismiss">&times;</button>';
    el.querySelector('.dz-uss-x').addEventListener('click', function () {
      el.remove();
      try { sessionStorage.setItem('dz_sale_strip', 'off'); } catch (e) {}
    });
    document.body.insertBefore(el, document.body.firstChild);
    var timer = el.querySelector('.dz-uss-timer');
    var iv = setInterval(function () {
      var left = ends - Date.now();
      if (left <= 0 || !document.body.contains(el)) { clearInterval(iv); el.remove(); return; }
      timer.textContent = countdownText(left);
    }, 1000);
  }

  // ---- "Shipping to" confirmation at the checkout handoff ----
  // Checkout itself is Shopify-hosted (CAD only), so the cart page + cart drawer are
  // the last surfaces we own. Auto-detect the region, let the customer correct it,
  // and set expectations: US shoppers learn the card is charged in CAD with a US$
  // estimate BEFORE they hit checkout; Canadians get the free-shipping threshold.
  function cartTotalCad() {
    var el = document.querySelector('.totals__total-value[data-cad-amt]');
    var amt = el ? parseFloat(el.getAttribute('data-cad-amt')) : NaN;
    return isNaN(amt) ? null : amt;
  }
  function regionBlockHtml() {
    var r = region();
    var total = cartTotalCad();
    var note;
    if (r === 'US') {
      note = 'Your card is charged in Canadian dollars' +
        (total ? ', about <b>US$' + usdFor(total) + '</b>' : '') +
        '. Your bank converts automatically.';
    } else {
      note = 'Free shipping on Canadian orders over CA$120.';
    }
    var other = r === 'US' ? 'Canada' : 'the United States';
    return '<div class="dz-reg-line">Shipping to: <b>' + (r === 'US' ? 'United States' : 'Canada') + '</b>' +
      ' <button type="button" class="dz-reg-switch" data-to="' + (r === 'US' ? 'CA' : 'US') + '">Change to ' + other + '</button></div>' +
      '<p class="dz-reg-note">' + note + '</p>';
  }
  function regionBlocks() {
    // Anchor points: cart page CTA block + cart drawer footer. Idempotent per render.
    var anchors = [];
    var cartCtas = document.querySelector('.cart__ctas');
    if (cartCtas && cartCtas.parentElement) anchors.push({ parent: cartCtas.parentElement, before: cartCtas });
    var drawerFooter = document.querySelector('.cart-drawer .drawer__footer, cart-drawer .drawer__footer');
    if (drawerFooter) anchors.push({ parent: drawerFooter, before: drawerFooter.firstChild });
    anchors.forEach(function (a) {
      var box = a.parent.querySelector(':scope > .dz-region');
      if (!box) {
        box = document.createElement('div');
        box.className = 'dz-region';
        a.parent.insertBefore(box, a.before);
        box.addEventListener('click', function (e) {
          var btn = e.target.closest('.dz-reg-switch');
          if (btn) setRegion(btn.getAttribute('data-to'));
        });
      }
      var html = regionBlockHtml();
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }

  function init() {
    apply();
    usStrip();
    saleStrip();
    // re-apply on Shopify dynamic renders (variant change, section load, cart drawer).
    document.addEventListener('shopify:section:load', scheduleApply);
    mo = new MutationObserver(scheduleApply);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
